import { DimensionKeys } from '../../middleware/google-analytics';
import { getSearchParameters } from '../state';
import { getZlogPageType, getZlogRollupBucket } from '../utils/pageCategories';

// pageCategory = ZlogPageType & GA Content Group
// pageType = Category
// This should be refactored on all pages to be more clear
const analytics = {
    pageCategory: state => getZlogPageType(state),
    rollUpBucket: state => getZlogRollupBucket(state),
    pageType: () => 'Search',
    pageSpecificCustomDimensions: state => {
        const getCustomDimensionValue = value => value && parseInt(value, 10) > 0 ? `${value}:` : '0: None';
        const params = getSearchParameters(state);
        return [
            {
                dimension: DimensionKeys.Placemark,
                value: getCustomDimensionValue(),
            },
            {
                dimension: DimensionKeys.Specialty,
                value: getCustomDimensionValue(params.specialtyId),
            },
            {
                dimension: DimensionKeys.Procedure,
                value: getCustomDimensionValue(params.procedureId),
            },
            {
                dimension: DimensionKeys.InsuranceCarrier,
                value: getCustomDimensionValue(params.carrierId),
            },
            {
                dimension: DimensionKeys.InsurancePlan,
                value: getCustomDimensionValue(params.planId),
            },
            {
                dimension: DimensionKeys.Language,
                value: getCustomDimensionValue(params.languageId),
            },
        ];
    },
};

export default analytics;
